import { IBookableService } from '@/store/types/Service';
import {OrderDetailResponseOrder} from "@/services/types/OrderDetailResponse";

export default class BookableServiceFilter {

    private servicesToExcludePackagingDisposal =
        ["VerpackungsEntsorgung","VerpackungsEntsorgungXL","VerpackungsEntsorgungVP", "Sofamontage", "Moebelmontage", "Aufbauservice", "M"];
    private packagingArrayRemoval = ["VerpackungsEntsorgung","VerpackungsEntsorgungXL","VerpackungsEntsorgungVP"]
    /**
     *
     * This method decides if service 'Verpackungsentsorgung' can be offered
     * @param bookableServices
     * @param order
     */
    public getFilteredBookableServicesPackagingDisposal(bookableServices: IBookableService[], order: OrderDetailResponseOrder) {
      
        if (order.services.length > 0) {
            for (const servicePosition of order.services) {
                for (const serviceToExcludePackagingDisposal of this.servicesToExcludePackagingDisposal) {
                    if (servicePosition.name === serviceToExcludePackagingDisposal) {
                     return this.filterServiceByKey(bookableServices,this.packagingArrayRemoval);
                    }
                }
            }
        }
        // No Filter for DeliveryOrder & Exchange Order
        if (order.shipments.filter(s=>s.type == "Delivery").length > 0) {
            return bookableServices;
        }

        // Filter if PickupOrder
        if (order.shipments.filter(s=>s.type == "Pickup").length > 0) {
            return this.filterServiceByKey(bookableServices, this.packagingArrayRemoval);
        }
        return bookableServices;
    }

    //return filtered bookable service list
    private filterServiceByKey(bookableServices: IBookableService[], BookableServiceFilter: string[]) {

        const result = bookableServices.filter(bookableService => !BookableServiceFilter.includes(bookableService.key));
        
        return result;
    }
}

